<div class="glance-section">
  <div class="glance-shell">

    <div class="glance-visual" aria-hidden="true">
      <div class="glance-blob"></div>
      <img class="glance-img" src="images/webps/admin-mobile.png" alt="" />

      <div class="glance-stat glance-stat--top">
        <span class="glance-stat-value">320</span>
        <span class="glance-stat-label">Active leads</span>
      </div>

      <div class="glance-stat glance-stat--bottom">
        <span class="glance-stat-value">92%</span>
        <span class="glance-stat-label">On-time follow-ups</span>
      </div>
    </div>

    <div class="glance-text">
      <p class="glance-label">Your Business, At a Glance</p>
      <h2 class="glance-heading">See Everything Your Team Is Doing</h2>
      <p class="glance-desc">
        Live reports, pending approvals, and business analytics — right on the dashboard,
        updated the moment something changes. No digging through spreadsheets to find out
        how the day is going.
      </p>

      <ul class="glance-points">
        <li><span class="glance-point-icon">📊</span> Real-time sales and pipeline reports</li>
        <li><span class="glance-point-icon">🔔</span> Instant alerts for approvals and updates</li>
        <li><span class="glance-point-icon">📱</span> The same view, on desktop or mobile</li>
      </ul>
    </div>

  </div>
</div>
